




















import Vue from 'vue';
import NOC from '@/class/common/const';
import * as models from '@/class/models/views/app';
import VariableInput, * as vi from '@/components/util/VariableInput.vue';

export default Vue.extend({
  name: 'Invitation',
  components: { VariableInput },
  props: {
    error : Object,
  },
  data() {
    return {
      accountData: new models.CAuth(),
      items: [
        {key: 'password', name: '新しいパスワード', type: vi.INPUT_TYPE.PASSWORD, placeholder: '半角大小英数字を1文字ずつ含む8文字以上', required: true, checks: [vi.CHECK_TYPE.PASSWORD], error: '', max: 40 },
        {key: 'passwordConfirm', name: '新しいパスワード(確認用)', type: vi.INPUT_TYPE.PASSWORD, placeholder: '半角大小英数字を1文字ずつ含む8文字以上', required: true, checks: [vi.CHECK_TYPE.PASSWORD], error: '', max: 40 },
      ] as vi.IVariableInput[],
    };
  },
  computed: {
    APP_MODE() { return NOC.APP.MODE; },
  },
  watch: {
    error: {
      deep: true,
      handler(newValue: any) {
        const target = this.items.filter((v) => (v.key === newValue.key));
        target[0].error = newValue.error;
      },
    },
  },
  methods: {
    onClickInvitation() {
      // vallidation check
      if (vi.checkValues(this.accountData, this.items) > 0) {
        return;
      }
      // パスワードが確認と一致しない場合
      if (this.accountData.password !== this.accountData.passwordConfirm) {
        // todo:直刺しやめたい
        this.items[1].error = 'パスワードが一致しません';
        return;
      }
      this.$emit('invitation', this.accountData);
    },
  },
});
